module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"title":"FORMLAR","formType":"Form Tipi","formNo":"Form No","version":"Versiyon","createdAt":"Oluşturulma Tarihi","chooseFormType":"Form Tipi Seçin"},"en":{"title":"FORMS","formType":"Form Type","formNo":"Form No","version":"Version","createdAt":"Created At","chooseFormType":"Choose a Form Type"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/views/Doc/Forms/SiteForms.vue
// module id = ykcd
// module chunks = 1